import React, { FC } from 'react';

import styled from '@emotion/native';
import { ActivityIndicator } from "react-native";

import Error from '@assets/icons/error';
import Done from '@assets/icons/done';
import { STATE } from '@lib/constants';

const Container = styled.View`
    width: 70px;
    height: 70px;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
`;

const Activity: FC<Props> = ({  state }) => {

    return (
        <>
            { (state == STATE.LOADING) && <ActivityIndicator size={60} color="#005ACE" /> }

            { (state == STATE.DONE) &&  <Container><Done /></Container> }

            { (state == STATE.ERROR) && <Container><Error /></Container> }
        </>
    );

};

type Props = {
    state?: number;
};


export default Activity;